module.exports = __webpack_public_path__ + "static/media/projects.526544ac.jpg";